import {injectable} from 'inversify';

import {ChoiceQuestionModel} from './ChoiceQuestion.model';

@injectable()
export class ChoiceQuestionFactory {
  create(props: ChoiceQuestionModel.Props) {
    return new ChoiceQuestionModel(props);
  }
}
